<template>
  <div class="el-stripe">
    <div class="emd-tabbar jsTabbar _bordered">
      <ul class="emd-tabbar__list">
        <li class="emd-tabbar__item">
          <a
            class="emd-tabbar__link"
            v-on:click="changeTab('info')"
            v-bind:class="{ _active: tabActive === 'info' }"
          >
            <span class="emd-text">{{ $t('customer.detail.tab-info') }}</span>
          </a>
        </li>
        <li
          class="emd-tabbar__item"
          v-if="permissionIsEnabled('order:search')"
        >
          <a
            class="emd-tabbar__link"
            v-on:click="changeTab('orders')"
            v-bind:class="{ _active: tabActive === 'orders' }"
          >
            <span class="emd-text">{{ $t('customer.detail.tab-orders') }}</span>
          </a>
        </li>
        <li
          class="emd-tabbar__item"
          v-if="
            componentIsEnabled('sidemenu', 'subscriptions') &&
            permissionIsEnabled('subscription:search')
          "
        >
          <a
            class="emd-tabbar__link"
            v-on:click="changeTab('subscriptions')"
            v-bind:class="{ _active: tabActive === 'subscriptions' }"
          >
            <span class="emd-text">{{
              $t('customer.detail.tab-subscriptions')
            }}</span>
          </a>
        </li>
        <li
          class="emd-tabbar__item"
          v-if="
            componentIsEnabled('sidemenu', 'invoices') &&
            permissionIsEnabled('invoice:search')
          "
        >
          <a
            class="emd-tabbar__link"
            v-on:click="changeTab('invoices')"
            v-bind:class="{ _active: tabActive === 'invoices' }"
          >
            <span class="emd-text">{{
              $t('customer.detail.tab-invoices')
            }}</span>
          </a>
        </li>
        <li
          class="emd-tabbar__item"
          v-if="permissionIsEnabled('charge:search')"
        >
          <a
            class="emd-tabbar__link"
            v-on:click="changeTab('charges')"
            v-bind:class="{ _active: tabActive === 'charges' }"
          >
            <span class="emd-text">{{
              $t('customer.detail.tab-charges')
            }}</span>
          </a>
        </li>
        <li
          class="emd-tabbar__item"
          v-if="permissionIsEnabled('customer.cards:get')"
        >
          <a
            class="emd-tabbar__link"
            v-on:click="changeTab('cards')"
            v-bind:class="{ _active: tabActive === 'cards' }"
          >
            <span class="emd-text">{{ $t('customer.detail.tab-cards') }}</span>
          </a>
        </li>
      </ul>
    </div>
    <customer-info v-if="tabActive === 'info'" />
    <customer-orders
      v-if="tabActive === 'orders' && permissionIsEnabled('order:search')"
    />
    <customer-subscriptions
      v-if="
        tabActive === 'subscriptions' &&
        componentIsEnabled('sidemenu', 'subscriptions') &&
        permissionIsEnabled('subscription:search')
      "
    />
    <customer-invoices
      v-if="
        tabActive === 'invoices' &&
        componentIsEnabled('sidemenu', 'invoices') &&
        permissionIsEnabled('invoice:search')
      "
    />
    <customer-charges
      v-if="tabActive === 'charges' && permissionIsEnabled('charge:search')"
    />
    <customer-cards
      v-if="tabActive === 'cards' && permissionIsEnabled('customer.cards:get')"
    />
  </div>
</template>
<script>
import CustomerInfo from '@/views/Customers/CustomersDetail/CustomerInfo.vue'
import CustomerOrders from '@/views/Customers/CustomersDetail/CustomerOrders.vue'
import CustomerSubscriptions from '@/views/Customers/CustomersDetail/CustomerSubscriptions.vue'
import CustomerInvoices from '@/views/Customers/CustomersDetail/CustomerInvoices.vue'
import CustomerCharges from '@/views/Customers/CustomersDetail/CustomerCharges.vue'
import CustomerCards from '@/views/Customers/CustomersDetail/CustomerCards.vue'
export default {
  name: 'CustomersDetail',
  components: {
    CustomerInfo,
    CustomerOrders,
    CustomerSubscriptions,
    CustomerInvoices,
    CustomerCharges,
    CustomerCards
  },
  data () {
    return {
      tabActive: 'info'
    }
  },
  methods: {
    changeTab (tab) {
      this.tabActive = tab
      this.$router
        .push({ name: 'customersDetail', params: { tab: tab } })
        .catch(err => err)
    },
    componentIsEnabled (section, component) {
      return this.$store.getters.componentIsEnabled(section, component)
    },
    permissionIsEnabled (action) {
      return this.$store.getters.permissionIsEnabled(action)
    }
  },
  beforeMount () {
    if (!this.$route.params.id.includes('cus_')) {
      this.$router.push({ name: 'customers' }).catch(err => err)
    }
    this.tabActive = this.$route.params.tab
  },
  mounted () {
    const $tabbar = Array.from(document.querySelectorAll('.jsTabbar'))
    let startX
    let scrollLeft
    let isDown = false
    $tabbar.forEach(function (el, idx) {
      el.addEventListener(
        'mousewheel',
        function (e) {
          el.scrollLeft += e.deltaY
        },
        { passive: true }
      )

      el.addEventListener(
        'mousedown',
        function (e) {
          isDown = true
          startX = e.pageX - el.offsetLeft
          scrollLeft = el.scrollLeft
        },
        { passive: true }
      )

      el.addEventListener(
        'mousemove',
        function (e) {
          if (!isDown) return
          const x = e.pageX - el.offsetLeft
          const walk = (x - startX) * 2
          el.scrollLeft = scrollLeft - walk
        },
        { passive: true }
      )

      el.addEventListener(
        'mouseup',
        function (e) {
          isDown = false
        },
        { passive: true }
      )

      el.addEventListener(
        'touchstart',
        function (e) {
          isDown = true
          if (e.touches.length > 0) {
            startX = e.touches[0].pageX - el.offsetLeft
          } else {
            startX = e.pageX - el.offsetLeft
          }
          scrollLeft = el.scrollLeft
        },
        { passive: true }
      )

      el.addEventListener(
        'touchmove',
        function (e) {
          if (!isDown) return
          let x = 0
          if (e.touches.length > 0) {
            x = e.touches[0].pageX - el.offsetLeft
          } else {
            x = e.pageX - el.offsetLeft
          }
          const walk = (x - startX) * 2
          el.scrollLeft = scrollLeft - walk
        },
        { passive: true }
      )

      el.addEventListener(
        'touchend',
        function (e) {
          isDown = false
        },
        { passive: true }
      )
    })
  }
}
</script>
